<form [formGroup]="form" id="islas-card">

    <div class="modal-header bg-light">
      <h4 class="modal-title">Nuevo Pedido Combustible</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close(false)"></button>
    </div>
  
    <div class="modal-body">

        <!-- Inicio del despacho -->
        <div class="mb-3 row">
          <label for="fechaFormControl" class="col-sm-4 col-form-label">Fecha y hora:</label>
          <div #fechaHora class="col-sm-6">
            <div class="input-group">
              <input type="date" class="form-control" formControlName="fechaFormControl" placeholder="aaaa-mm-dd"
                name="dp" title="Campo obligatorio." container="body" [(ngModel)]="modelFecha" ngbDatepicker #d="ngbDatepicker"
                readonly/>
              <div class="input-group-append">
                <button type="button" class="input-group-btn btn btn-secondary" (click)="d.toggle()">
                  <i class="fa fa-calendar" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <ngb-timepicker [(ngModel)]="modelHora" [meridian]="true" formControlName="horaFormControl"
              [readonlyInputs]="true"></ngb-timepicker>
            <div class="alert alert-danger"
              *ngIf="form.invalid && this.form.hasError('fechaInicioMayorAhora')">
              Esta cargando una fecha de inicio de despacho en el futuro.
            </div>
          </div>
        </div>

        <div class="row">
          <div class="mb-3 row col-md-12">
            <label for="productoFormControl" class="col-md-4 col-form-label">Producto:</label>
            <div class="col-md-8">
                <select [compareWith]="compareProductos" id="productoFormControl" class="form-select"
                  ngbTooltip="Seleccione el producto." formControlName="productoFormControl">
                  <option value='' selected disabled>Seleccione un producto...</option>
                  <option *ngFor="let p of productos" [ngValue]="p">
                      ({{ p.codigoProducto }}) - {{ p.nombreProducto }}
                  </option>
                </select>
                <div class="alert alert-danger"
                  *ngIf="(this.productoFormControl.invalid && this.productoFormControl.errors.required && (this.productoFormControl.dirty || this.productoFormControl.touched))">
                  Debe seleccionar un producto obligatoriamente.
                </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="mb-3 row col-md-12">
            <label for="cantidadFormControl" class="col-md-4 col-form-label">Cantidad:</label>
            <div class="col-md-8">
                <input class="form-control" formControlName="cantidadFormControl" maxlength="10" [min]="1"
                  appOnlyNumber>
                <div class="alert alert-danger"
                  *ngIf="(this.cantidadFormControl.invalid && (this.cantidadFormControl.errors.required || this.cantidadFormControl.errors.min)&& (this.cantidadFormControl.dirty || this.cantidadFormControl.touched))">
                  Debe ingresar una cantidad válida.
                </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="mb-3 row col-md-12">
            <div class="justify-content-center d-flex flex-wrap gap-2">
              <button *ngFor="let boton of botonesGrupo"
                  class="btn"
                  [ngClass]="boton.seleccionado ? 'btn-success' : 'btn-outline-primary'"
                  (click)="seleccionarGrupo(boton)">
                {{ boton.nombre }}
              </button>      
            </div>
          </div>
        </div>

        <div class="row">
          <div class="mb-3 row col-md-12">
            <label for="emailFormControl" class="col-md-4 col-form-label">Nuevo destinatario:</label>
            <div class="col-md-7">
                <input type="email" class="form-control" formControlName="emailFormControl" maxlength="80">
                <div class="alert alert-danger"
                  *ngIf="(this.emailFormControl.invalid && this.emailFormControl.errors.email && (this.emailFormControl.dirty || this.emailFormControl.touched))">
                  Debe ingresar un correo válido.
                </div>
            </div>
            <div class="col-md-1">
              <button type="button" ngbTooltip="Agregar mail asignado" (click)="agregarMailDestinatario()" class="btn btn-success">
                <i class="fa fa-plus"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="row item-border">
          <div class="mb-3 row col-12">
            <label class="col-4 col-form-label">Destinatarios:</label> 
            <div class="col-8 card-body">
              <div *ngFor="let email of listaEmails">
                <div class="grid-email align-items-start mt-1">
                  <span class="break-email">{{ email }}</span>
                  <button type="button"
                          ngbTooltip="Quitar mail asignado"
                          (click)="borrarMailDestinatario(email)"
                          class="btn btn-danger btn-sm">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>  
          </div>
        </div>
    
    </div><!-- Del modal body -->
  
    <div class="modal-footer bg-light">
      <span class="border">
        <button type="button" [disabled]="this.guardandoDatos" class="btn btn-primary" 
          (click)="guardar()">
          <span *ngIf="!guardandoDatos">Guardar</span>
            <div *ngIf="guardandoDatos" class="d-flex align-items-center">
              <div class="spinner-border text-light spinner-border-sm" role="status"></div>
              <span>Guardando...</span>
            </div>
        </button>
      </span>
  
      <span class="border">
        <button type="button" class="btn btn-secondary" [disabled]="this.guardandoDatos"
          (click)="activeModal.close(false)">Cancelar</button>
      </span>
    </div>
  </form>